import React from 'react';

export default React.createContext({
  parentScrollNode: null,
});
